import React from "react";
import { motion } from "framer-motion";
// import { BsEnvelope, BsInstagram, BsLinkedin } from "react-icons/bs";
import SocialMedia from "../Components/SocialMedia";


function Footer() {
    return (
        <div id="contact" className="h-full ">
            <motion.div
                whileInView={{ y: [50, 0], opacity: [0, 1] }}
                transition={{ duration: 1, ease: "easeInOut" }}
                className="p-3 md:p-10 w-full text-center">
                <center>
                    <div className="w-fit font-mono font-extrabold text-transparent text-4xl md:text-5xl bg-clip-text bg-gradient-to-r from-[#ffe100] to-[#951cff]">
                        Contact
                    </div>

                    <div className="text-2xl font-face-p flex justify-center items-center">
                        <SocialMedia isContact={true} />
                    </div>
                </center>
            </motion.div>
        </div>
    );
}

export default Footer;
